<div [formGroup]="form_group">
  <div class="table-responsive" *ngIf="masters[field.masterPropName] && masters[field.masterPropName].length">
    <ng-container [formArrayName]="field.fieldID"
      *ngFor="let question of form_group.get(field.fieldID)['controls']; let i = index;">
      <div [formGroupName]="i" class="mb-3">
        <div class="question mb-2" [title]="question.title">
          <span class="multi-line-truncate-2">
            {{i+1}}) {{masters[field.masterPropName][i].title | translate}}
          </span>
        </div>
        <div style="vertical-align: middle;">
          <mat-radio-group formControlName="optionCode">
            <mat-radio-button class="mx-1" *ngFor="let item of masters[field.masterPropName][i].options"
              [value]="item.optionCode">
              {{item.title | translate}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div *ngIf="masters[field.masterPropName][i].optionType == 2">
          <input type="text" class="form-control" formControlName="inputAnswer" />
        </div>
      </div>
    </ng-container>
  </div>
</div>



<!-- <div [formGroup]="form_group">
  <div class="table-responsive" *ngIf="masters[field.masterPropName] && masters[field.masterPropName].length">
    <table class="table table-striped">
      <thead>
        <th class="col-md-6 col-width-100">
          {{ "ALERT.questions" | translate }}
        </th>
        <th class="col-md-3">
          {{ "ALERT.response" | translate }}
        </th>
      </thead>
      <tbody>
        <ng-container [formArrayName]="field.fieldID"
          *ngFor="let question of form_group.get(field.fieldID)['controls']; let i = index;">
          <tr [formGroupName]="i">
            <td style="white-space: normal !important; vertical-align: middle;" [title]="question.title">
              <span class="multi-line-truncate-2">
                {{masters[field.masterPropName][i].title | translate}}
              </span>
            </td>
            <td style="vertical-align: middle;">
              <mat-radio-group formControlName="optionCode">
                <mat-radio-button class="mx-1" *ngFor="let item of masters[field.masterPropName][i].options"
                  [value]="item.optionCode">
                  {{item.title | translate}}
                </mat-radio-button>
              </mat-radio-group>
            </td>
            <td *ngIf="masters[field.masterPropName][i].optionType == 2">
              <input type="text" class="form-control" formControlName="inputAnswer" />
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div> -->
